import React, { useState } from 'react';
import { ManText } from "@craft-design-system/core-components-react";
import Summary from './Summary';
import Ride_Analysis from './Ride_analysis';
import BatteryAnalysis from './battery_analysis';
import ChargingAnalysis from './charging_analysis';
import StopLocationnew from './StopLocationnew';
import Activity from './Activity';

const TabComponent = ({ initial_tab }) => {
  const [selectedTab, setSelectedTab] = useState(initial_tab);
  const [locationSubTab, setLocationSubTab] = useState('Stop Location');

  const tabStyle = {
    padding: '10px 0px',
    cursor: 'pointer',
    fontWeight: 'bold',
    borderBottom: '#d3d3d3 solid 1px',
    marginRight: '5px',
    width: '500px',
    display: 'flex',
    justifyContent: 'center',
    color: 'black',
    background: 'white'
  };

  const selectedTabStyle = {
    ...tabStyle,
    borderBottom: 'red solid 2px',
    color: '#E40045'
  };

  const subTabStyle = {
    ...tabStyle,
    width: '200px'
  };

  const selectedSubTabStyle = {
    ...selectedTabStyle,
    width: '200px'
  };

  return (
    <div>
      {/* Main Tabs */}
      <div style={{ display: 'flex', justifyContent: 'space-around', backgroundColor: 'white' }}>
        {['Summary', 'Ride Analysis', 'tab2', 'tab3'].map(tab => (
          <span
            key={tab}
            style={selectedTab === tab ? selectedTabStyle : tabStyle}
            onClick={() => setSelectedTab(tab)}
          >
            <ManText className="tabs1" variant={"heading-s"} as={"span"}>
              {{
                'Summary': 'Summary',
                'Ride Analysis': 'Ride Analysis',
                'tab2': 'Battery',
                'tab3': 'Charging',
                // 'tab4': 'Location'
              }[tab]}
            </ManText>
          </span>
        ))}
      </div>

      {/* Subtabs for Location */}
      {/* {selectedTab === 'tab4' && (
        <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'white' }}>
          {['Stop Location', 'Activity'].map(subTab => (
            <span
              key={subTab}
              style={locationSubTab === subTab ? selectedSubTabStyle : subTabStyle}
              onClick={() => setLocationSubTab(subTab)}
            >
              <ManText variant={"heading-s"} as={"span"}>
                {subTab}
              </ManText>
            </span>
          ))}
        </div>
      )} */}

      {/* Tab Content */}
      <div style={{ display: selectedTab === 'Summary' ? 'block' : 'none' }}>
        <Summary />
      </div>
      <div style={{ display: selectedTab === 'Ride Analysis' ? 'block' : 'none' }}>
        <Ride_Analysis />
      </div>
      <div style={{ display: selectedTab === 'tab2' ? 'block' : 'none' }}>
        <BatteryAnalysis />
      </div>
      <div style={{ display: selectedTab === 'tab3' ? 'block' : 'none' }}>
        <ChargingAnalysis />
      </div>
      
      {/* Location Subtab Content */}
      {/* {selectedTab === 'tab4' && (
        <div style={{ marginTop: '20px' }}>
          <div style={{ display: locationSubTab === 'Stop Location' ? 'block' : 'none' }}>
            <StopLocationnew />
          </div>
          <div style={{ display: locationSubTab === 'Activity' ? 'block' : 'none' }}>
            <Activity />
          </div>
        </div>
      )} */}
    </div>
  );
};

export default TabComponent;